import React from 'react';

import { TMessage } from '_modules/message/types/entity';

import { TChatConfig } from './entity';

export type TChatState = {
  config: TChatConfig;
  conversationId: null | string;
  isLoading: boolean;
  isOpen: boolean;
  messages: TMessage[];
  name: string;
};

export type TChatAction =
  | {
      changes: Partial<TMessage>;
      id: string;
      type: 'patchMessage';
    }
  | {
      conversationId: null | string;
      type: 'askSucceeded';
    }
  | {
      message: TMessage;
      type: 'appendMessage';
    }
  | {
      resetConversation: boolean;
      type: 'askFailed';
    }
  | {
      type: 'askStarted';
    }
  | {
      type: 'close';
    }
  | {
      type: 'open';
    };

export interface IChatContext {
  dispatch: React.Dispatch<TChatAction>;
  state: TChatState;
}

export const defaultChatState: TChatState = {
  config: {
    excludePatterns: null,
    icon: null,
    includePatterns: null,
    manualUrl: null,
    name: '',
  },
  conversationId: null,
  isLoading: false,
  isOpen: false,
  messages: [],
  name: '',
};

export const defaultChatContext = {
  dispatch: () => undefined,
  state: defaultChatState,
};
